  window.syncRangeToRadio = function() {
      const rangeSlider = document.getElementById('--steps');
      if (!rangeSlider) return;

      const selectedValue = parseInt(rangeSlider.value, 10);

      // Click the radio button with matching data-range-index
      const radio = document.querySelector(`input[type="radio"][data-range-index="${selectedValue}"]`);

      if (radio && !radio.checked) {
          radio.click();
      }
  };
  window.handleServiceAreaChange = function (checkbox) {
  console.log('Checked:', checkbox.checked);
  let optionObject = document.querySelector('fieldset.--option-name-service-area.product-form__input--pill');
//   console.log("optionObject",optionObject);
  let radioButtons = optionObject.querySelectorAll('input[type=radio]');
  if(checkbox.checked == true){
radioButtons[1].click();
  } else {
    radioButtons[0].click();
  }

}

